import { makeStyles } from "@/utils"
import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	header: {
		position: "relative",
		backgroundColor: colors.purple[50],
		overflow: "hidden"
	},
	image: {
		width: "100%",
		height: 360,
		objectFit: "cover",
		display: "block"
	},
	badge: {
		position: "absolute",
		bottom: theme.spacing(2),
		left: theme.spacing(2),
		backgroundColor: colors.gray[0],
		border: `1px solid ${colors.purple[200]}`,
		color: colors.purple[600],
		fontWeight: 600,
		fontSize: 11,
		letterSpacing: "0.05em"
	},
	closeButton: {
		position: "absolute",
		top: theme.spacing(1),
		right: theme.spacing(1),
		borderRadius: "50%",
		padding: theme.spacing(0.75),
		backgroundColor: colors.gray[200],
		color: colors.gray[0],
		"&:hover": {
			backgroundColor: colors.gray[300]
		}
	}
}))

export default useStyles
